import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import "ag-grid-enterprise";
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown';
import TextInput from '../../components/UIComponent/TextInput';
import TransactionReoprtServices from '../../services/axiosServices/apiServices/TransactionReportsServices';
import SwalServices from '../../services/swalServices/SwalServices';
import { getAuthProps } from '../../utils/AuthenticationLibrary';
import { getFinancialYearDates } from '../../utils/DateUtils';
import { encryptAES } from '../../utils/Encryption';
import { Navigate } from 'react-router-dom';
import moment from 'moment';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

ModuleRegistry.registerModules([AllCommunityModule]);

class PartyWisePendingReport extends Component {
    constructor(props) {
        super(props);
        this.transactionReoprtServices = new TransactionReoprtServices();
        this.SwalServices = new SwalServices();
        this.gridRef = React.createRef();
        this.state = {
            route: null,
            idCompany: null,
            rowData: [],
            colDefs: [
                { field: "party", headerName: "Party", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.14, flex: 1.4 },
                { field: "drawingNo", headerName: "Drawing No", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.09, flex: 1 },
                { field: "searchText", headerName: "Search Text", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.09, flex: 1 },
                { field: "itemName", headerName: "Item Name", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.16, flex: 1.6 },
                { field: "orderNo", headerName: "Order No", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.07, flex: 0.8 },
                { field: "orderDate", headerName: "Order Date", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.07, flex: 0.8 },
                { field: "pendingQty", headerName: "Pending Qty", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.07, flex: 0.7 },
            ],
            requestDetails: {
                type: 'WO',
                typeList: [
                    { value: 'WO', label: 'Work Order' },
                    { value: 'JW', label: 'Job Work' },
                    { value: 'PO', label: 'Purchase Order' },
                ],
                startDate: getFinancialYearDates().fromDate,
                endDate: getFinancialYearDates().toDate,
                idParty: "",
                partyList: [],
            },
            paginationPageSize: 50,
            rowHeight: 40,
        };
    }

    componentDidMount = () => {
        let prop = getAuthProps();
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany }, () => {
                this.restoreAndLoad();
            });
        }
    }

    // restore last search (filters + rows) so browser-back returns to the same report state
    restoreAndLoad = () => {
        let details = this.state.requestDetails;
        let rowData = this.state.rowData;
        try {
            const saved = sessionStorage.getItem('partyWisePendingReportState');
            if (saved) {
                const s = JSON.parse(saved);
                details = {
                    ...details,
                    type: s.type,
                    startDate: s.startDate,
                    endDate: s.endDate,
                    idParty: s.idParty,
                };
                rowData = s.rowData || [];
            }
        } catch (e) { /* ignore corrupt storage */ }
        this.setState({ requestDetails: details, rowData }, () => this.loadPartyList());
    }

    handleChange = (event, name) => {
        let details = this.state.requestDetails;
        details[name] = event.target.value;
        this.setState({ requestDetails: details });
    }

    handleChangeForDropdown = (event, name) => {
        let details = this.state.requestDetails;
        details[name] = event.value;
        this.setState({ requestDetails: details }, () => {
            if (name === "type") {
                // reset selected party and reload the correct list (WO=customer, JW/PO=vendor)
                let d = this.state.requestDetails;
                d.idParty = "";
                this.setState({ requestDetails: d }, () => this.loadPartyList());
            }
        });
    }

    loadPartyList = () => {
        // load only parties that have pending records for the selected type (WO/JW/PO)
        let request = {
            type: this.state.requestDetails.type,
            idCompany: this.state.idCompany,
        };
        this.transactionReoprtServices.getReportPendingParties(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = (response.responseItem.responseContent || []).map((x) => ({
                    value: x.idPartyAccount,
                    label: x.partyACName,
                }));
                let details = this.state.requestDetails;
                details.partyList = data;
                this.setState({ requestDetails: details });
            }
        });
    }

    getRecords = () => {
        const d = this.state.requestDetails;
        let request = {
            type: d.type,
            idCompany: this.state.idCompany,
            fromDate: d.startDate ? d.startDate : null,
            toDate: d.endDate ? d.endDate : null,
            idParty: d.idParty ? d.idParty : null,
        };
        this.transactionReoprtServices.getPartyWisePendingReport(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = (response.responseItem.responseContent || []).map((x) => ({
                    ...x,
                    orderDate: x.orderDate ? moment(x.orderDate).format('DD-MM-YYYY') : ''
                }));
                this.setState({ rowData: data });
                try {
                    sessionStorage.setItem('partyWisePendingReportState', JSON.stringify({
                        type: d.type,
                        startDate: d.startDate,
                        endDate: d.endDate,
                        idParty: d.idParty,
                        rowData: data,
                    }));
                } catch (e) { /* ignore storage quota / private mode */ }
            } else {
                this.SwalServices.Error(response.message);
            }
        });
    }

    onRowDoubleClicked = (event) => {
        let idOrder = event.data.idOrder;
        if (!idOrder) return;
        const enc = encryptAES(idOrder);
        const type = this.state.requestDetails.type;
        let path = '';
        if (type === 'WO') path = `/wo-receive?id=${enc}`;
        else if (type === 'JW') path = `/material-job-work?id=${enc}`;
        else if (type === 'PO') path = `/purchase-order?id=${enc}`;
        if (path) this.setState({ route: path });
    };

    getPinnedBottomRowData = () => {
        if (!this.state.rowData || this.state.rowData.length === 0) return [];
        const totalPending = this.state.rowData.reduce((sum, r) => sum + (Number(r.pendingQty) || 0), 0);
        return [{ party: "Total", drawingNo: "", searchText: "", itemName: "", orderNo: "", orderDate: "", pendingQty: totalPending }];
    }

    onExportExcel = () => {
        if (this.gridRef.current && this.gridRef.current.api) {
            const csvData = this.gridRef.current.api.getDataAsCsv();
            const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'PartyWisePending_Report.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    onExportPdf = () => {
        if (!this.gridRef.current || !this.gridRef.current.api) return;
        const doc = new jsPDF();
        const d = this.state.requestDetails;
        const typeLabel = d.typeList.find(x => x.value === d.type)?.label || '';
        const pageWidth = doc.internal.pageSize.getWidth();
        const headerLines = [
            `Party Wise Pending - ${typeLabel}`,
            `From: ${d.startDate ? moment(d.startDate).format('DD-MM-YYYY') : '-'}  To: ${d.endDate ? moment(d.endDate).format('DD-MM-YYYY') : '-'}`,
        ];
        const lineHeight = 8, padding = 2;
        const totalHeaderHeight = headerLines.length * lineHeight + padding * 2;
        doc.setFillColor(245, 245, 245);
        doc.rect(0, 0, pageWidth, totalHeaderHeight, 'F');
        doc.setFontSize(12);
        doc.setTextColor(80, 80, 80);
        headerLines.forEach((line, i) => {
            const textWidth = doc.getTextWidth(line);
            doc.text(line, (pageWidth - textWidth) / 2, padding + (i + 1) * lineHeight - 2);
        });

        const cols = this.state.colDefs;
        const body = [];
        this.gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
            body.push(cols.map(c => node.data[c.field]));
        });
        const pinnedCount = this.gridRef.current.api.getPinnedBottomRowCount();
        for (let i = 0; i < pinnedCount; i++) {
            const p = this.gridRef.current.api.getPinnedBottomRow(i);
            body.push(cols.map(c => p.data[c.field]));
        }

        autoTable(doc, {
            head: [cols.map(c => c.headerName)],
            body: body,
            startY: totalHeaderHeight + 4,
            styles: { fontSize: 8 },
            headStyles: { fillColor: [63, 140, 255], textColor: 255 },
        });
        doc.save("PartyWisePending-report.pdf");
    };

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='party-wise-pending-report'>
                <div className="data-display">
                    <div className="data-display-inner">
                        <div className='search-grp bg-white shadow-normalShadow rounded-[10px] p-[10px] mb-[10px]'>
                            <p className='mb-[5px] font-semibold text-blue text-[16px]'>Select details</p>
                            <div className='item-set flex gap-[15px]'>
                                <div className='item-grp w-full grid grid-cols-6 gap-[15px] items-start'>
                                    <div className='input-grp'>
                                        <label>Type</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Type"
                                            options={this.state.requestDetails.typeList}
                                            value={this.state.requestDetails.type ? this.state.requestDetails.typeList.find(x => x.value === this.state.requestDetails.type) : 0}
                                            onChange={(event) => this.handleChangeForDropdown(event, "type")}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>From Date</label>
                                        <TextInput type="date" id="startDate" name="startDate"
                                            value={this.state.requestDetails.startDate}
                                            handleChange={(event) => this.handleChange(event, "startDate")} />
                                    </div>
                                    <div className="input-grp">
                                        <label>To Date</label>
                                        <TextInput type="date" id="endDate" name="endDate"
                                            value={this.state.requestDetails.endDate}
                                            handleChange={(event) => this.handleChange(event, "endDate")} />
                                    </div>
                                    <div className='input-grp w-full col-span-2'>
                                        <label>Select party (optional)</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Party"
                                            options={this.state.requestDetails.partyList}
                                            value={this.state.requestDetails.idParty ? this.state.requestDetails.partyList.find(x => x.value === this.state.requestDetails.idParty) : 0}
                                            onChange={(event) => this.handleChangeForDropdown(event, "idParty")}
                                        />
                                    </div>
                                    <div className='btn-grp'>
                                        <button onClick={() => this.getRecords()} className='prm-btn'>Search</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="table w-full cursor-default bg-white shadow-normalShadow rounded-[10px] pb-[50px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[56vh] w-full rounded-[5px]">
                                <div className="table-inner flex items-center justify-between mb-2">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Party wise pending</h1>
                                    {this.state.rowData.length > 0 ?
                                        <div className='btn-grp flex items-center gap-2.5'>
                                            <button className='prm-btn h-fit text-[14px] rounded-[8px] px-[16px] py-[8px]'
                                                onClick={() => this.onExportExcel()}>Export to Excel</button>
                                            <button className='prm-btn h-fit text-[14px] rounded-[8px] px-[16px] py-[8px]'
                                                onClick={() => this.onExportPdf()}>Export to PDF</button>
                                        </div>
                                        : null}
                                </div>
                                <AgGridReact
                                    ref={this.gridRef}
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    pinnedBottomRowData={this.getPinnedBottomRowData()}
                                    rowClassRules={{ "sum-row": (params) => params.node.rowPinned === "bottom" }}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PartyWisePendingReport;
